<div class="welcome-div">
    <div><img class="logo" src="/assets/img/endoo-Logo2.png" draggable="false" /></div>
    <p>Willkommen in <strong>endooControl</strong>.</p>
    <p><i>„May the Wifi be with you“</i></p>
    <div class="buttons">
        <a mat-raised-button color="primary" target="_blank" href="https://endoospot.de/hilfe/">Hilfe/Kontakt</a>
        <a mat-raised-button color="primary" target="_blank"
            href="https://endoospot.de/category/changelog/">Neuigkeiten</a>
    </div>
</div>